import { Assets } from "pixi.js"

/** Wheel plate + rim — replaces Pixi `drawCenter` disk and `drawOuterRing` stroke. */
export const ROULETTE_BACKGROUND_URL = "/images/roulette-background.png"

export const ROULETTE_BACKGROUND_TEXTURE_ALIAS = "roulette-background"

let loadPromise: Promise<void> | null = null

export function ensureRouletteBackgroundPreloaded(): Promise<void> {
  if (!loadPromise) {
    loadPromise = (async () => {
      try {
        Assets.add({
          alias: ROULETTE_BACKGROUND_TEXTURE_ALIAS,
          src: ROULETTE_BACKGROUND_URL,
        })
      } catch {
        // duplicate alias on remount
      }
      await Assets.load(ROULETTE_BACKGROUND_TEXTURE_ALIAS)
    })()
  }
  return loadPromise
}

void ensureRouletteBackgroundPreloaded().catch(() => {})
